module.exports = __webpack_public_path__ + "static/media/ThePowerOfNatureENG.bff2303b.vtt";